import InventoryTypeBadge from './InventoryTypeBadge'

export default InventoryTypeBadge
